import { getEnv } from '~/adapters/config/env';

export function usersPasswordEditEmbeddedPath() {
    return `${getEnv('ACCOUNTS_PROFILES_URL')}/users/password/edit_embedded`;
}
